module.exports = __webpack_public_path__ + "static/hand.5e73cd93.svg";